import changeCheckbox from "./change-checkbox";
import changeRadio from "./change-radio";
import select from "./select";

/**
 * Change / Select / Check
 * @param {CustomEventProps} event
 */
const change = (event) => {
  const trigger = /** @type {TriggerProps} */ (event.details?.get("trigger"));
  const main = /** @type {MainClassProps} */ (event.details?.get("main"));
  const type = /** @type {EventListProps} */ (trigger.get("original-name"));
  const target = /** @type {HTMLInputElement} */ (event.target);
  const radio = target.type === "radio";

  if (type === "check") {
    if (radio) {
      changeRadio(main, target, trigger);
    } else {
      changeCheckbox(main, target, trigger);
    }
  }

  if (type === "select") {
    select(target, trigger, main);
  }
}

export default change;